module.exports = __webpack_public_path__ + "img/laptop.221935b.svg";